import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Loader2 } from "lucide-react";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

// Renders every page of a PDF (blob URL) at the container width — works on mobile browsers that can't embed PDFs in an iframe.
export function PdfPages({ url }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(600);
  const [pages, setPages] = useState(0);
  useEffect(() => {
    const el = ref.current; if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setWidth(Math.max(240, Math.floor(e.contentRect.width))));
    ro.observe(el); return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className="h-full overflow-y-auto bg-slate-100 p-3" data-testid="kn-pdf-pages">
      <Document file={url} onLoadSuccess={(d) => setPages(d.numPages)} loading={<p className="flex items-center gap-2 p-4 text-xs text-slate-500"><Loader2 size={13} className="animate-spin" /> Memuat PDF…</p>}
        error={<p className="p-4 text-xs text-[#EF4444]">PDF tidak bisa ditampilkan — gunakan tab "Teks untuk asisten".</p>}>
        {Array.from({ length: pages }, (_, i) => (
          <div key={i} className="mb-3 overflow-hidden rounded-xl bg-white shadow-sm" data-testid="kn-pdf-page">
            <Page pageNumber={i + 1} width={width - 24} renderAnnotationLayer={false} />
          </div>
        ))}
      </Document>
      {pages > 0 && <p className="pb-1 text-center text-[11px] text-slate-400">{pages} halaman</p>}
    </div>
  );
}
